import { cn } from '@/utils/index';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type SpinnerContentProps = React.HTMLAttributes<SVGElement>;

export const Spinner = ({ className, ...props }: SpinnerContentProps) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'spinner',
  });

  return (
    <div className='text-text-brand-primary' data-testid='spinner' aria-live='polite'>
      <Loader2 className={cn('animate-spin', className)} {...props} aria-hidden />
      <span className='sr-only size-0'>{t('ariaLabel')}</span>
    </div>
  );
};
